
import {getConnection} from './services';

export const getFirebaseConfig = () => {
  const connection = getConnection('fb');
  return connection.options.serviceAccount;
}

export const getApiConfig = () => {

  const connection = getConnection('ap');
  const { host,mode,clientApikey } = connection;
  return {
    uri: host,
    apiKey: clientApikey,
    mode
  }
};

// temporary check on authorization to do stuff
export const getIsBoss = userID =>
  userID &&
  ['446304582111297537', '1000000060', '447497076265353218'].indexOf(userID) !==
  -1;
